// extracted by mini-css-extract-plugin
export default {"basicPlanCreate":"styles_basicPlanCreate__HtrKI","head":"styles_head__5O4Mb"};